import { render, staticRenderFns } from "./assignbranch.vue?vue&type=template&id=d436bf36&"
import script from "./assignbranch.vue?vue&type=script&lang=js&"
export * from "./assignbranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports